module.exports = __webpack_public_path__ + "static/media/BSM_model_image.35046de2.png";